import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createMainReducer } from '../reducers';
import { routerMiddleware } from './middlewares/router';
export function createAppStore(initialState, context) {
  var composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(createMainReducer(), initialState, composeEnhancers(applyMiddleware(routerMiddleware, thunk.withExtraArgument(context))));
}